// eslint-disable-next-line
export default {
    GOOGLE : {
        reCaptcha: "6LfHfkEaAAAAAK_SV2-RTzAHbZl2uZb5_IFIgvRw"
    }
}